 import React from 'react';
 
 const StoryDetails = () => {
     return (
          <div>
               
          </div>
     );
 };
 
 export default StoryDetails;